import { useQuery, gql } from '@apollo/client';

import { PREMIUM_PLAN_ID } from 'components/billing/constants';
import { isPast, parseISO } from 'date-fns';
import { userHasPermission, MANAGE_BILLING } from 'helpers/permissions';
import { useCurrentUser } from 'javascripts/hooks';
import { Plan } from '../../types';

export const PREMIUM_SAMPLE_ELIGIBLE = gql`
  query PremiumSampleEligible {
    viewer {
      id
      billing {
        availablePlans {
          id
          identifier
          sampleEligible
        }
      }
      company {
        trialEnd
      }
    }
  }
`;

function getIsInTrial(trialEnd: string) {
  if (trialEnd) {
    const isoTrialEnd = parseISO(trialEnd);
    const pastTrial = isPast(isoTrialEnd);
    return !pastTrial;
  }
  return false;
}

const usePremiumSampleEligible = () => {
  const { data, error } = useQuery(PREMIUM_SAMPLE_ELIGIBLE);
  const user = useCurrentUser();
  const canManageBilling = userHasPermission(user, MANAGE_BILLING);
  const hasEligiblePremiumSamplePlan =
    data?.viewer?.billing?.availablePlans?.find(
      (plan: Plan) => plan.identifier === PREMIUM_PLAN_ID,
    )?.sampleEligible || false;

  const isPremiumSampleEligible =
    !error &&
    canManageBilling &&
    hasEligiblePremiumSamplePlan &&
    !getIsInTrial(data?.viewer?.company?.trialEnd);

  return {
    isPremiumSampleEligible,
  };
};

export default usePremiumSampleEligible;
